
document.addEventListener("DOMContentLoaded", function() {

  const slider = document.querySelector(".custom-product-slider");
  const next = document.querySelector(".next");
  const prev = document.querySelector(".prev");
  const thumbnails = document.querySelectorAll(".thumbnail");

  if (!slider) return;

  let slides = slider.querySelectorAll(".custom-slide");

  const totalSlides = slides.length;
  let isLoopEnabled = totalSlides > 1;

  // =========================
  // 👉 CLONE ONLY IF NEEDED
  // =========================
  if (isLoopEnabled) {
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);

    slider.appendChild(firstClone);
    slider.insertBefore(lastClone, slides[0]);

    slides = slider.querySelectorAll(".custom-slide");
  }

  let index = isLoopEnabled ? 1 : 0;

  slider.scrollLeft = slider.offsetWidth * index;

  // =========================
  // 👉 VIDEO HANDLER
  // =========================
  function handleVideoPlayback() {
    const allVideos = slider.querySelectorAll("video");

    allVideos.forEach(video => {
      video.pause();
      video.currentTime = 0;
    });

    const currentSlide = slides[index];
    if (!currentSlide) return;

    const activeVideo = currentSlide.querySelector("video");

    if (activeVideo) {
      activeVideo.play().catch(() => {});
    }
  }

  // =========================
  // 👉 SLIDE FUNCTION
  // =========================
  function goToSlide(i) {
    slider.scrollTo({
      left: slider.offsetWidth * i,
      behavior: "smooth"
    });

    setTimeout(handleVideoPlayback, 400);
  }

  // =========================
  // 👉 ARROWS
  // =========================
  if (!isLoopEnabled) {
    if (next) next.style.display = "none";
    if (prev) prev.style.display = "none";
  }

  if (next) {
    next.addEventListener("click", function(e){
      e.preventDefault();
      if (!isLoopEnabled) return;
      index++;
      goToSlide(index);
    });
  }

  if (prev) {
    prev.addEventListener("click", function(e){
      e.preventDefault();
      if (!isLoopEnabled) return;
      index--;
      goToSlide(index);
    });
  }

  // =========================
  // 👉 TOUCH SWIPE
  // =========================
  let startX = 0;
  let endX = 0;

  slider.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener("touchmove", e => {
    endX = e.touches[0].clientX;
  });

  slider.addEventListener("touchend", () => {
    if (!isLoopEnabled) return;

    let diff = startX - endX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        index++;
      } else {
        index--;
      }
      goToSlide(index);
    }
  });

  // =========================
  // 👉 LOOP FIX
  // =========================
  if (isLoopEnabled) {
    slider.addEventListener("scroll", () => {
      const slideWidth = slider.offsetWidth;

      if (slider.scrollLeft >= slideWidth * (slides.length - 1)) {
        index = 1;
        slider.scrollTo({ left: slideWidth * index, behavior: "auto" });
      }

      if (slider.scrollLeft <= 0) {
        index = slides.length - 2;
        slider.scrollTo({ left: slideWidth * index, behavior: "auto" });
      }

      // Thumbnail active state
      let realIndex = index - 1;

      if (realIndex < 0) realIndex = thumbnails.length - 1;
      if (realIndex >= thumbnails.length) realIndex = 0;

      thumbnails.forEach(t => t.removeAttribute("aria-current"));
      if (thumbnails[realIndex]) {
        thumbnails[realIndex].setAttribute("aria-current", "true");
      }
    });
  }

  // =========================
  // 👉 THUMBNAILS
  // =========================
  thumbnails.forEach((thumb, i) => {
    thumb.addEventListener("click", function(e) {
      e.preventDefault();

      if (!isLoopEnabled) return;

      index = i + 1;
      goToSlide(index);
    });
  });

  // =========================
  // 👉 INIT
  // =========================
  handleVideoPlayback();

});


